<template>
    <div class="EnergyReport scrollstyle"  @scroll='handleScroll'>
      <!-- v-loading="loading" -->
        <div class="title row-center" style="justify-content: space-between;">
          <div class="row-center">
            <el-date-picker
              :editable="false"
              :picker-options="pickerOptions"
              :clearable="false"
              class="dateSelect"
              format="yyyy-MM"
              v-model="date"
              type="month"
              :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
            >
            </el-date-picker>
            <el-button plain class="btn per" @click="perM">上一月</el-button>
            <el-button
              class="btn next"
              plain
              @click="nextM"
              :disabled="nextDayDisabled"
            >
              下一月
            </el-button>
          </div>
          <div class="right">
            
          </div>
        </div>
        <div class="cont">
          <div class="line">总体情况</div>
          <div class="panel">
            <div class="text">
              本能耗分析报告为<span>{{getinfo.buildingName}}</span>项目的<span>{{month}}份</span>综合能耗汇报。共有建筑<span>{{getinfo.buildingFloors}}</span>，总面积为<span>{{getinfo.buildingArea}}</span>。{{month}}{{getinfo.buildingName}}综合能效等级评价为<span>A</span>（总用电量为<span>{{overall.energy}}</span>,总用水量为{{overall.water}}，总用热量为--,总用冷量为--。
              总体能耗较上月<label for="" v-if="prevTotalNum<0">减少</label>
              <label for="" v-else>增加</label><span>{{prevTotalNum.toFixed(2)}} %</span>）。
            </div>
            <div class="" style="height:32vh">
              <charts id="EnergyReport" :option="EnergyReport"></charts>
            </div>
            <div class="Notes">图：各类能耗增长趋势</div>
            <el-table  :data="tableData"  style="width: 100%">
              <el-table-column prop="total" label="总能耗（折标煤）">
              </el-table-column>
              <el-table-column prop="energy" align="center" label="用电量">
              </el-table-column>
              <el-table-column prop="water" align="center" label="用水量">
                <!-- <template slot-scope="scope">
                    --
                </template> -->
              </el-table-column>
              <el-table-column prop="heat" align="center" label="用热量">
                <template slot-scope="scope">
                    --
                </template>
              </el-table-column>
              <el-table-column prop="cooling" align="center" label="用冷量">
                <template slot-scope="scope">
                    --
                </template>
              </el-table-column>
            </el-table>
            <div class="Notes">表：能耗统计</div>
            <el-table  :data="tableRank" style="width: 100%">
              <el-table-column  label="序号">
                <template slot-scope="scope">
                  {{ scope.$index+1 }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="建筑名称" > </el-table-column>
              <el-table-column label="总能耗（折标煤）">
                <el-table-column prop="total_grade" label="能效等级" >
                </el-table-column>
                <el-table-column prop="total_rank" label="能效排名" >
                  <!-- <template slot-scope="scope">
                    <span v-if="scope.row.total_grade=='A'">1</span>
                    <span v-else>2</span>
                </template> -->
                </el-table-column>
              </el-table-column>
              <el-table-column label="用电量" >
                <el-table-column prop="power_grade" label="能效等级">
                </el-table-column>
                <el-table-column prop="power_rank" label="能效排名" >
                  <!-- <template slot-scope="scope">
                    <span v-if="scope.row.power_grade=='A'">1</span>
                    <span v-else>2</span>
                  </template> -->
                </el-table-column>
              </el-table-column>
              <el-table-column label="用水量">
                <el-table-column prop="water_grade" label="能效等级" >
                  <template slot-scope="scope">
                    <div v-if="scope.$index==0">{{scope.row.water_grade}}</div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
                <el-table-column prop="water_rank" label="能效排名">
                  <template slot-scope="scope">
                    <div v-if="scope.$index==0">{{scope.row.water_rank}}</div>
                      <div v-else>--</div>
                  </template>
                  <!-- <template slot-scope="scope">--</template> -->
                </el-table-column>
              </el-table-column>
              <el-table-column label="用热量">
                <el-table-column prop="heat_grade" label="能效等级" >
                  <template slot-scope="scope">--</template>
                </el-table-column>
                <el-table-column prop="heat_grade" label="能效排名" >
                  <!-- <template slot-scope="scope">
                      <span v-if="scope.row.heat_grade=='A'">1</span>
                      <span v-else>2</span>
                  </template> -->
                
                  <template slot-scope="scope">--</template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="用冷量" >
                <el-table-column prop="cooling_grade" label="能效等级" >
                  <template slot-scope="scope">--</template>
                </el-table-column>
                <el-table-column prop="cooling_grade" label="能效排名">
                  <!-- <template slot-scope="scope">
                      <span v-if="scope.row.cooling_grade=='A'">1</span>
                      <span v-else>2</span>
                  </template> -->
                
                  <template slot-scope="scope">--</template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <div class="Notes">表：能效排名</div>
          </div>
        </div>
        <div class="cont" v-if="rollScrollShow">
          <div class="line">能耗同比</div>
          <div class="panel">
            <div class="text">
              <label v-for="(item,index) in tableDataRatio" :key="index" v-if="index<=1">
                本月用{{item.name}}量{{item.period}}{{item.unit}} ，同期用{{item.name}}量{{item.same}}{{item.unit}}，
                <label v-if="item.lv>=0"><span :class="item.lv>0?'red':'no'">同比增长{{item.lv}} %</span> ，增长值{{item.growth}}{{item.unit}}</label>
                <label v-else><span>同比下降{{item.lv}} %</span> ，下降值{{item.growth}}{{item.unit}}</label>。
              </label>
              <label v-for="(item,index) in tableDataRatio" :key="index" v-if="index>1">
                本月用{{item.name}}量-- ，同期用{{item.name}}量--，
                <label >同比下降--，下降值--</label>。
              </label>
              
              <label for="" v-if="tableDataRatio[0].lv<0">
                本月能耗整体低于上月消耗量，其中用电量下降幅度最大，请继续合理规划用能。
              </label>
              <label for="" v-else>
                本月能耗整体高于上月消耗量，其中用电量上升幅度最大，请继续合理规划用能。
              </label>
            </div>
            <div class="chin">
              <div class="land">
                <div class="item">
                  <Histogram
                    id="EnergyReportRatio"
                    :option="EnergyReportRatioData[0]"
                    unit="kWh"
                  ></Histogram>
                </div>
                <div class="Notes">图：用电同比</div>
              </div>
              <div class="land">
                <div class="item">
                  <Histogram
                    id="EnergyReportRatio1"
                    :option="EnergyReportRatioData[1]"
                    unit="m³"
                  ></Histogram>
                </div>
                <div class="Notes">图：用水同比</div>
              </div>
              <div class="land">
                <div class="item">
                  <Histogram
                    id="EnergyReportRatio2"
                    :option="EnergyReportRatioData[2]"
                    unit="GJ"
                  ></Histogram>
                </div>
                <div class="Notes">图：用热同比</div>
              </div>
              <div class="land">
                <div class="item">
                  <Histogram
                    id="EnergyReportRatio3"
                    :option="EnergyReportRatioData[3]"
                    unit="GJ"
                  ></Histogram>
                </div>
                <div class="Notes">图：用冷同比</div>
              </div>
            </div>
  
            <el-table  :data="tableDataRatio" style="width: 100%">
              <el-table-column prop="name" label="能耗类型"> </el-table-column>
              <el-table-column prop="period" align="center" label="本期">
                <template slot-scope="scope">
                  {{ scope.row.period }}
                  <span v-if="scope.$index == 0"> kWh</span>
                  <span v-else-if="scope.$index == 1"> m³</span>
                  <!-- <span v-else>GJ</span> -->
                </template>
              </el-table-column>
              <el-table-column prop="same" align="center" label="同期">
                <template slot-scope="scope">
                  {{ scope.row.same }}<span v-if="scope.$index == 0"> kWh</span
                  >
                  <span v-else-if="scope.$index == 1"> m³</span>
                  <!-- <span v-else>GJ</span> -->
                </template>
              </el-table-column>
              <el-table-column prop="lv" align="center" label="同比增长率">
                <template slot-scope="scope"> {{ scope.row.lv }}<span v-if="scope.$index <= 1"> %</span></template>
              </el-table-column>
              <el-table-column prop="growth" align="center" label="增长值">
                <template slot-scope="scope">
                  {{ scope.row.growth }}<span v-if="scope.$index == 0"> kWh</span
                  >
                  <span v-else-if="scope.$index == 1"> m³</span>
                  <!-- <span v-else>GJ</span> -->
                </template>
              </el-table-column>
            </el-table>
            <div class="Notes">表：能耗统计</div>
          </div>
        </div>
        <div class="cont" v-if="rollScrollShow">
          <div class="line">能耗环比</div>
          <div class="panel">
            <div class="text">
              <label v-for="(item,index) in tableDataChain" :key="index" v-if="index<=1">
                本月用{{item.name}}量{{item.period}}{{item.unit}} ，上月用{{item.name}}量{{item.same}}{{item.unit}}，
                <label v-if="item.lv>=0"><span :class="item.lv>0?'red':'no'">环比增长{{item.lv}} %</span> ，增长值{{item.growth}}{{item.unit}}</label>
                <label v-else><span>环比下降{{item.lv}} %</span> ，下降值{{item.growth}}{{item.unit}}</label>。
              </label>
              <label v-for="(item,index) in tableDataChain" :key="index" v-if="index>1">
                本月用{{item.name}}量-- ，上月用{{item.name}}量--，
                <label>环比下降--，下降值--</label>。
              </label>
              <label for="" v-if="tableDataChain[0].lv<0">
                本月能耗整体低于上月消耗量，其中用电量下降幅度最大，请继续合理规划用能。
              </label>
              <label for="" v-else>
                本月能耗整体高于上月消耗量，其中用电量上升幅度最大，请继续合理规划用能。
              </label>
            </div>
            <div class="chin">
              <div class="land">
                <div class="item">
                  <Histogram
                    id="EnergyReportChin"
                    type="chain"
                    :option="EnergyReportChinData[0]"
                    unit="kWh"
                  ></Histogram>
                </div>
                <div class="Notes">图：用电同比</div>
              </div>
              <div class="land">
                <div class="item">
                  <Histogram
                    id="EnergyReportChin1"
                    type="chain"
                    :option="EnergyReportChinData[1]"
                    unit="m³"
                  ></Histogram>
                </div>
                <div class="Notes">图：用水同比</div>
              </div>
              <div class="land">
                <div class="item">
                  <Histogram
                    id="EnergyReportChin2"
                    type="chain"
                    :option="EnergyReportChinData[2]"
                    unit="GJ"
                  ></Histogram>
                </div>
                <div class="Notes">图：用热同比</div>
              </div>
              <div class="land">
                <div class="item">
                  <Histogram
                    id="EnergyReportChin3"
                    type="chain"
                    :option="EnergyReportChinData[3]"
                    unit="GJ"
                  ></Histogram>
                </div>
                <div class="Notes">图：用冷同比</div>
              </div>
            </div>
  
            <el-table  :data="tableDataChain" style="width: 100%">
              <el-table-column prop="name" label="能耗类型"> </el-table-column>
              <el-table-column prop="period" align="center" label="本期">
                <template slot-scope="scope">
                  {{ scope.row.period }}<span v-if="scope.$index == 0"> kWh</span
                  >
                  <span v-else-if="scope.$index == 1"> m³</span
                  >
                  <!-- <span v-else>GJ</span> -->
                </template>
              </el-table-column>
              <el-table-column prop="same" align="center" label="上期">
                <template slot-scope="scope">
                  {{ scope.row.same }}<span v-if="scope.$index == 0"> kWh</span
                  >
                  <span v-else-if="scope.$index == 1"> m³</span
                  >
                  <!-- <span v-else>GJ</span> -->
                </template>
              </el-table-column>
              <el-table-column prop="lv" align="center" label="环比增长率">
                <template slot-scope="scope"> {{ scope.row.lv }}<span v-if="scope.$index <= 1"> %</span> </template>
              </el-table-column>
              <el-table-column prop="growth" align="center" label="增长值">
                <template slot-scope="scope">
                  {{ scope.row.growth }}<span v-if="scope.$index == 0"> kWh</span
                  >
                  <span v-else-if="scope.$index == 1"> m³</span
                  >
                  <!-- <span v-else>GJ</span> -->
                </template>
              </el-table-column>
            </el-table>
            <div class="Notes">表：能耗统计</div>
          </div>
        </div>
        <div class="cont" v-if="rollScrollShow">
          <div class="line">能耗结构</div>
          <div class="panel">
            <div class="text">
              本月总能耗中用电占比<span> {{tableSort[0].energylv}} %</span>
              ，用水占比<span> {{tableSort[0].waterlv}} %</span>
              ，用热占比--
              ，用冷占比--
              ，其中用电量占比较高。
              <label for="" v-if="maxsuboption.name=='空调'">
                  分项能耗中空调能耗占比最多，占总能耗的<span>{{maxsuboption.val}} %</span>
              ，建议及时更改空调运行模式，可采用智能调节模式，依据温湿度、二氧化碳浓度等自动调节。
              </label>
              <label for="" v-if="maxsuboption.name=='照明'">
                  分项能耗中照明能耗占比最多，占总能耗的<span>{{maxsuboption.val}} %</span>
              ，请注意人走灯灭，减少浪费，建议使用可智能感应、智能调节的照明设备。
              </label>
              <label for="" v-if="maxsuboption.name=='动力'">
                  分项能耗中动力能耗占比最多，占总能耗的<span>{{maxsuboption.val}} %</span>
              ，请注意检查机床、电机等大型设备的是否合规使用，节约用电。
              </label>
              
            </div>
            <div class="chin">
              <div class="land" style="width:40%">
                <div class="item" style="height:25vh">
                  <charts id="Classification1" :option="Classification1"></charts>
                </div>
                <div class="Notes">图：分类能耗</div>
              </div>
              <div class="land" style="width:40%">
                <div class="item" style="height:25vh">
                  <charts id="Classification2" :option="Classification2"></charts>
                </div>
                <div class="Notes">图：分项能耗</div>
              </div>
            </div>
            <el-table  :data="tableSort" style="width: 100%">
              <el-table-column  label="电">
                <el-table-column prop="energy" label="数值">
                  <template slot-scope="scope">
                    {{ scope.row.energy }} kWh
                  </template>
                </el-table-column>
                <el-table-column prop="energylv" label="占比">
                  <template slot-scope="scope">
                    {{scope.row.energylv}} %
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column  align="center" label="水">
                <el-table-column prop="water" label="数值">
                  <template slot-scope="scope"> {{ scope.row.water }} m³ </template>
                  <!-- <template slot-scope="scope"> -- </template> -->
                </el-table-column>
                <el-table-column prop="waterlv" label="占比">
                  <template slot-scope="scope">
                    {{ scope.row.waterlv }} %
                  </template>
                  <!-- <template slot-scope="scope"> -- </template> -->
                </el-table-column>
              </el-table-column>
              <el-table-column align="center" label="热">
                <el-table-column prop="heat" label="数值">
                  <!-- <template slot-scope="scope"> {{ scope.row.heat }} GJ </template> -->
                  
                  <template slot-scope="scope"> -- </template>
                </el-table-column>
                <el-table-column prop="heatlv" label="占比">
                  <!-- <template slot-scope="scope">
                    {{  scope.row.heatlv }} %
                  </template> -->
                  
                  <template slot-scope="scope"> -- </template>
                </el-table-column>
              </el-table-column>
              <el-table-column  align="center" label="冷">
                <el-table-column prop="cooling" label="数值">
                  <!-- <template slot-scope="scope">
                    {{ scope.row.cooling }} GJ
                  </template> -->
                  
                  <template slot-scope="scope"> -- </template>
                </el-table-column>
                <el-table-column prop="coolinglv" label="占比">
                  <!-- <template slot-scope="scope">
                    {{
                      scope.row.coolinglv
                    }} %
                  </template> -->
                  
                  <template slot-scope="scope"> -- </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <div class="Notes">表：分类能耗结构</div>
            <el-table  :data="tableItem" style="width: 100%">
              <el-table-column  label="空调">
                <el-table-column prop="air" label="数值">
                  <template slot-scope="scope"> {{ scope.row.air }} kWh </template>
                </el-table-column>
                <el-table-column prop="airlv" label="占比">
                  <template slot-scope="scope">
                    {{ scope.row.airlv ? scope.row.airlv : "0.00" }} %
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column  label="照明">
                <el-table-column prop="illumine" label="数值">
                  <template slot-scope="scope"> {{ scope.row.illumine }} kWh </template>
                </el-table-column>
                <el-table-column prop="illuminelv" label="占比">
                  <template slot-scope="scope">
                    {{ scope.row.illuminelv ? scope.row.illuminelv : "0.00" }} %
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="动力">
                <el-table-column prop="power" label="数值">
                  <template slot-scope="scope"> {{ scope.row.power }} kWh </template>
                </el-table-column>
                <el-table-column prop="powerlv" label="占比">
                  <template slot-scope="scope">
                    {{ scope.row.powerlv ? scope.row.powerlv : "0.00" }} %
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column  label="其他">
                <el-table-column prop="other" label="数值">
                  <template slot-scope="scope">
                    0.00 kWh
                  </template>
                </el-table-column>
                <el-table-column prop="other" label="占比">
                  <template slot-scope="scope">
                    0.00 %
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <div class="Notes">表：分项能耗结构</div>
          </div>
        </div>
        <div class="cont" v-if="rollScrollShow">
          <div class="line">节能分析</div>
          <div class="panel">
            <div class="text">
              本月计划用电总量为{{planinfo.energy_plan}} kWh，实际用电{{planinfo.energy_reality}} kWh
  
              ，<label v-if="planinfo.energy_diff>0" ><span class="red">高于计划标准{{planinfo.energy_diff}} %</span>，超出电量{{planinfo.energy_reality-planinfo.energy_plan}} kWh</label>
                <label v-else><span>低于计划标准{{planinfo.energy_diff}} %</span>，节省电量{{planinfo.energy_plan-planinfo.energy_reality}} kWh</label>
              
              。本月计划用水总量为{{planinfo.water_plan}} m³ ，实际用水{{planinfo.water_reality}} m³
  
              ，<label v-if="planinfo.water_diff>0" ><span class="red">高于计划标准{{planinfo.water_diff}} %</span>，超出用量{{planinfo.water_reality-planinfo.water_plan}} m³</label>
                <label v-else><span>低于计划标准{{planinfo.water_diff}} %</span>，节省用量{{planinfo.water_plan-planinfo.water_reality}} m³</label>
  
              。本月计划用热总量为{{planinfo.heat_plan}} GJ，实际用热{{planinfo.heat_reality}} GJ
  
              ，<label v-if="planinfo.heat_diff>0"><span class="red">高于计划标准{{planinfo.heat_diff}} %</span>，超出热量{{planinfo.heat_reality-planinfo.heat_plan}} GJ</label>
                <label v-else><span>低于计划标准{{planinfo.heat_diff}} %</span>，节省热量{{planinfo.heat_reality-planinfo.heat_plan}} GJ</label>
  
              。本月计划用冷总量为{{planinfo.cooling_plan}} GJ，实际用冷{{planinfo.cooling_reality}} GJ
  
              ，<label v-if="planinfo.cooling_diff>0" ><span class="red">高于计划标准{{planinfo.cooling_diff}} %</span>，超出用量{{planinfo.cooling_reality-planinfo.cooling_plan}} GJ</label>
                <label v-else><span>低于计划标准{{planinfo.cooling_diff}} %</span>，超出用量{{planinfo.cooling_reality-planinfo.cooling_plan}} GJ</label>
  
              。请注意合理规划，节约用水、用热、用冷。
            </div>
            <el-table  :data="tableDataPlan" style="width: 100%">
              <el-table-column label="电">
                <el-table-column prop="energy_plan" label="计划用电">
                  <template slot-scope="scope">
                    {{ scope.row.energy_plan }} kWh
                  </template>
                </el-table-column>
                <el-table-column prop="energy_reality" label="实际用电">
                  <template slot-scope="scope">
                    {{ scope.row.energy_reality }} kWh
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="水">
                <el-table-column prop="water_plan" label="计划用水">
                  <template slot-scope="scope">
                    {{ scope.row.water_plan }} m³
                  </template>
                </el-table-column>
                <el-table-column prop="water_reality" label="实际用水">
                  <template slot-scope="scope">
                    {{ scope.row.water_reality }} m³
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="热">
                <el-table-column prop="heat_plan" label="计划用热">
                  <template slot-scope="scope">
                    {{ scope.row.heat_plan }} GJ
                  </template>
                </el-table-column>
                <el-table-column prop="heat_reality" label="实际用热">
                  <template slot-scope="scope">
                    {{ scope.row.heat_reality }} GJ
                  </template></el-table-column
                >
              </el-table-column>
              <el-table-column label="冷">
                <el-table-column prop="cooling_plan" label="计划用冷"
                  ><template slot-scope="scope">
                    {{ scope.row.cooling_plan }} GJ
                  </template>
                </el-table-column>
                <el-table-column prop="cooling_reality" label="实际用冷"
                  ><template slot-scope="scope">
                    {{ scope.row.cooling_reality }} GJ
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
            <div class="Notes">表：分类能耗结构</div>
          </div>
        </div>
        <div class="cont" v-if="rollScrollShow">
          <div class="line">附表</div>
          <div class="panel Schedule">
            <p v-for="(item,index) in reportList">{{index+1}}.{{item.name}} <span @click="
                $store.commit('exportDiagram', {
                  type: 'excel',
                  version: Math.random(),
                }),downFile=item
              ">下载</span></p>
          </div>
        </div>
        
        <!-- <div v-if="!rollScrollShow" class="row-center tip">
          <img src="@/assets/img/loading.png" class="loading">
        </div> -->
        <div style="height:150px" v-if="!rollScrollShow">
          <Loading LoadingId="rollScrollShowLoading" :scale="1.2"   />
        </div>
    </div>
</template>
  
  <script>
  import charts from "../../components/common/Charts.vue";
  import Histogram from "./components/Histogram.vue";
  import {
    ProjectCompareClassifiedPower,
    ProjectItemEnergy,
    planAndReality,
    ProjectConsumption,
    BuildingConsumption,
    convertedStandardCoal,
    treeBuilding,
    GetProJectInfo
  } from "../../api/power";
  import exportExcel from "../../util/excel";
  import Loading from '../../components/common/Loading.vue'
  import {
    perDay,
    perMonth,
    perYear,
    nextDay,
    nextMonth,
    nextYear,
    dateFormat,
    addDay,
    getAppointedDate,
  } from "../../util/DateUtil";
  export default {
    components: {
      charts,
      Histogram,
      Loading
    },
    data() {
      return {
        rollScrollShow:false, //滚动模拟懒加载
        pickerOptions: {
          firstDayOfWeek: 1,
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        date: new Date(),
        radio: "month",
        xmonth: [],
        tableData: [],
        tableDataRatio: [], //同比
        tableDataChain: [], //环比
        tableItem: [], //分项能耗
        tableRank: [], //
        tableSort: [], //分类能耗
        tableDataPlan: [], //节能计划
        EnergyReportData1: [],
        EnergyReportChinData: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        EnergyReportRatioData: [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ],
        ClassifiedData: [],
        ItemizedChart: [],
        getinfo:{},
        typelist:[
          {name:"电",unit:"kWh"},
          {name:"水",unit:"m³"},
          {name:"热",unit:"GJ"},
          {name:"冷",unit:"GJ"},
        ],
        downFile:{},
        PrevTotal:"", //上月总能耗
        loading:true,
        maxsuboption:{},
        tab:[
          {
            title: "总能耗（折标煤）",
            children: [
              {
                title: "能效等级",
                prop: "total_grade",
              },
              {
                title: "能效排名",
                prop: "total_rank",
              },
            ],
          },{
            title: "用电量",
            children: [
              {
                title: "能效等级",
                prop: "power_grade",
              },
              {
                title: "能效排名",
                prop: "power_rank",
              },
            ],
          },{
            title: "用水量",
            children: [
              {
                title: "能效等级",
                prop: "water_grade",
              },
              {
                title: "能效排名",
                prop: "water_rank",
              },
            ],
          },{
            title: "用热量",
            children: [
              {
                title: "能效等级",
                prop: "heat_grade",
              },
              {
                title: "能效排名",
                prop: "heat_rank",
              },
            ],
          },,{
            title: "用冷量",
            children: [
              {
                title: "能效等级",
                prop: "cooling_grade",
              },
              {
                title: "能效排名",
                prop: "cooling_rank",
              },
            ],
          },
        ],
        loops:[]
      };
    },
    computed: {
      nextDayDisabled() {
        let timestamp = dateFormat("YY-mm-dd", new Date());
        let endtime = dateFormat("YY-mm-dd", this.date);
        if (this.radio === "year") {
          timestamp = dateFormat("YY", new Date());
          endtime = dateFormat("YY", this.date);
        } else if (this.radio === "month") {
          timestamp = dateFormat("YY-mm", new Date());
          endtime = dateFormat("YY-mm", this.date);
        } else if (this.radio === "week") {
          timestamp = dateFormat("YY-mm-dd", new Date());
          endtime = dateFormat("YY-mm-dd", addDay(this.date, 5));
        }
        if (endtime >= timestamp) {
          return true;
        } else {
          return false;
        }
      },
      EnergyReport() {
        return {
          color: ["#F6BD16", "#6DC8EC", "#E8684A", "#9270CA"],
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#333333" //设置文字颜色
            },
            formatter: function (params) {
              let str = `${params[0].name}<br/>`;
              params.forEach((item, idx) => {
                  str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.data}</b><b style='font-size:14px;'> tce</b>`;
                  str += idx === params.length -1? '': '<br/>'
              })
              return str
            }
          },
          legend: {
            // orient: "vertical", //垂直显示
            // y: "10%", //延Y轴居中
            // x: "right", //居右显示
            icon: "rect",
            // align: "left",
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
              fontSize: 15,
              fontWeight: 800,
            },
          },
          grid: {
            top:"12%",
            left: "0%",
            right: "2%",
            bottom: "3%",
            containLabel: true,
          },
          title: {
            text: 'tce',
            textAlign:"left",
            left: -5,// 距离左边位置
            // top: -5,// 距离上面位置
            textStyle:{
              align:"left",
              fontWeight:'bold',
              fontSize:12,
              color: "#333",
              fontStyle:'italic'
            }
          },
          xAxis: {
            type: "category",
            data: this.xmonth,
            axisLabel:{
                fontSize:12,
                color: "#333",
                fontWeight:'bold'
            },
            axisTick: {
              show: false
            },
          },
          yAxis: {
            type: "value",
            // offset:10,
            // name: "tce",
            nameTextStyle: {
                align: "right",
                fontWeight:'bold',
                fontStyle:"italic",
                color: "#333",
            },
            splitLine:{
                show:true,
                lineStyle:{
                    type:'dashed',
                }
            },
            axisLabel:{
                fontSize:12,
                color: "#333",
                fontWeight:'bold'
            }
          },
          series: this.EnergyReportData1,
        };
      },
      Classification1() {
        return {
          color: ["#f6bd16", "#6dc8ec", "#E8684A", "#9270CA", "#6DC8EC"],
          tooltip: {
            trigger: "item",
            formatter: function (params) {
              return  `${params.marker} ${params.name}: <b style='font-size:18px;'>${params.value}</b><b style='font-size:14px;'> tce</b>`
            }
          },
          series: [
            {
              type: "pie",
              radius: ["40%", "65%"],
              center: ["50%", "50%"],
              label: {
                formatter: "{name|{b}}\n{time|{d} %}",
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 25,
                fontSize: "16rem",
                fontWeight: 800,
                fontWeight: "bold",
                rich: {
                  time: {
                    fontSize: "16rem",
                    color: "#0D94FF",
                    fontWeight: "bold",
                  },
                  name: {
                    fontSize: "16rem",
                    fontWeight: "bold",
                  },
                },
              },
              itemStyle: {
                // 此配置
                normal: {
                  borderWidth: 2,
                  borderColor: "#ffffff",
                },
              },
              labelLine: {
                show: true,
                lineStyle: {
                  width: 2,
                },
              },
              data: this.ClassifiedData,
            },
          ],
        };
      },
      Classification2() {
        return {
          color: ["#f6bd16", "#6dc8ec", "#e8684a", "#9270ca"],
          tooltip: {
            trigger: "item",
            formatter: function (params) {
              return  `${params.marker} ${params.name}: <b style='font-size:18px;'>${params.value}</b><b style='font-size:14px;'> tce</b>`
            }
          },
          series: [
            {
              type: "pie",
              radius: ["40%", "65%"],
              center: ["50%", "50%"],
              label: {
                formatter: "{name|{b}}\n{time|{c} %}",
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 25,
                fontSize: "16rem",
                fontWeight: "800",
                rich: {
                  time: {
                    fontSize: "16rem",
                    color: "#0D94FF",
                    fontWeight: "800",
                  },
                  name: {
                    fontSize: "16rem",
                    fontWeight: "bold",
                  },
                },
              },
              itemStyle: {
                // 此配置
                normal: {
                  borderWidth: 2,
                  borderColor: "#ffffff",
                },
              },
              labelLine: {
                show: true,
                lineStyle: {
                  width: 2,
                },
              },
              data: this.ItemizedChart,
            },
          ],
        };
      },
      month(){
        return dateFormat("YY年mm月", this.date)
      },
      planinfo(){
        return this.tableDataPlan[0]
      },
      reportList(){
        return [
          {name:"《"+this.month+"用电量时段报表》",value:"energy_time"},
          // {name:"《鲁泰大楼"+this.month+"用水量时段报表》",value:"water_time"},
          // {name:"《鲁泰大楼"+this.month+"用热量时段报表》",value:"heat_time"},
          // {name:"《鲁泰大楼"+this.month+"用冷量时段报表》",value:"cooling_time"},
          {name:"《"+this.month+"分项能耗报表》",value:"suboption"},
          {name:"《"+this.month+"用电同环比报表》",value:"energy_chain"},
          // {name:"《鲁泰大楼"+this.month+"用水同环比报表》",value:"water_chain"},
          // {name:"《鲁泰大楼"+this.month+"用热同环比报表》",value:"heat_chain"},
          // {name:"《鲁泰大楼"+this.month+"用冷同环比报表》",value:"cooling_chain"},
          {name:"《"+this.month+"计划和实际报表》",value:"plan_real"},
        ]
      },
      diagramStatus(){
        return this.$store.state.project.diagramStatus
      },
      //总体情况
      overall(){
        return this.tableData[0]
      },
      prevTotalNum(){
        if(this.PrevTotal==0){
          if((this.overall.num-this.PrevTotal)==0){
            return 0
          }else{
            return 100
          }
        }else{
          return ((this.overall.num-this.PrevTotal)/this.PrevTotal).toFixed(2)*100
        }
        
      }
    },
    watch: {
      date(n,o) {
        this.loading = true
        this.canvasDataRult();
        this.GetCompareRatio(); //同比
        this.GetCompareChain(); //环比
        this.Getproportion();
        this.GetProjectItemEnergy();
        this.GetPlan(); //计划
        this.GetproportionPrev(); //上月分类能耗
        this.GetCompareGrade();
      },
      diagramStatus(n){
        if(this.downFile.value == "energy_time"){
          if(n.type === 'excel' && this.EnergyReportData1[0].data.length > 0){
            let data = [
              [],[]
            ]
            for (let i = 1; i <= 31; i++) {
              data[0].push(i + "日");
            }
            data[1] = this.EnergyReportData1[0].data.map(e=>e+" kWh")
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "water_time"){
          if(n.type === 'excel' && this.EnergyReportData1[1].data.length > 0){
            let data = [
              [],[]
            ]
            for (let i = 1; i <= 31; i++) {
              data[0].push(i + "日");
            }
            data[1] = this.EnergyReportData1[1].data.map(e=>e+" kWh")
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "heat_time"){
          if(n.type === 'excel' && this.EnergyReportData1[2].data.length > 0){
            let data = [
              [],[]
            ]
            for (let i = 1; i <= 31; i++) {
              data[0].push(i + "日");
            }
            data[1] = this.EnergyReportData1[2].data.map(e=>e+" kWh")
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "cooling_time"){
          if(n.type === 'excel' && this.EnergyReportData1[3].data.length > 0){
            let data = [
              [],[]
            ]
            for (let i = 1; i <= 31; i++) {
              data[0].push(i + "日");
            }
            data[1] = this.EnergyReportData1[3].data.map(e=>e+" kWh")
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "suboption"){  //分项能耗
          if(n.type === 'excel' && this.tableItem.length > 0){
            let data = [
              ["空调","照明","动力"],
              [this.tableItem[0].air,this.tableItem[0].illumine,this.tableItem[0].power]
            ]
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "energy_chain"){  //电环比
          if(n.type === 'excel' && this.tableDataChain.length > 0){
            let data = [
              ["本期","上期","环比率",'增长值'],
              [this.tableDataChain[0].period+" kWh",this.tableDataChain[0].same+" kWh",this.tableDataChain[0].lv+" %",this.tableDataChain[0].growth+" kWh"]
            ]
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "water_chain"){  //水环比
          if(n.type === 'excel' && this.tableDataChain.length > 0){
            let data = [
              ["本期","上期","环比率",'增长值'],
              [this.tableDataChain[1].period+" m³",this.tableDataChain[1].same+" m³",this.tableDataChain[1].lv+" %",this.tableDataChain[1].growth+" m³"]
            ]
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "heat_chain"){  //热环比
          if(n.type === 'excel' && this.tableDataChain.length > 0){
            let data = [
              ["本期","上期","环比率",'增长值'],
              [this.tableDataChain[2].period+" GJ",this.tableDataChain[2].same+" GJ",this.tableDataChain[2].lv+" %",this.tableDataChain[2].growth+" GJ"]
            ]
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "cooling_chain"){  //冷环比
          if(n.type === 'excel' && this.tableDataChain.length > 0){
            let data = [
              ["本期","上期","环比率",'增长值'],
              [this.tableDataChain[3].period+" GJ",this.tableDataChain[3].same+" GJ",this.tableDataChain[3].lv+" %",this.tableDataChain[3].growth+" GJ"]
            ]
            exportExcel(data, this.downFile.name, [])
          }else {
            this.$message.warning("无图表数据！")
          }
        }else if(this.downFile.value == "plan_real"){  //计划与实际
          if(n.type === 'excel' && this.tableDataPlan.length > 0){
            let data = [
              ["电",null,"水",null,"热",null,'冷',null],
              ["计划用电","实际用电","计划用电","实际用电","计划用电","实际用电","计划用电","实际用电"],
              [this.tableDataPlan[0].energy_plan+" kWh",this.tableDataPlan[0].energy_reality+" kWh",
              this.tableDataPlan[0].water_plan+" m³",this.tableDataPlan[0].water_reality+" m³",
              this.tableDataPlan[0].heat_plan+" GJ",this.tableDataPlan[0].heat_reality+" GJ",
              this.tableDataPlan[0].cooling_plan+" GJ",this.tableDataPlan[0].cooling_reality+" GJ",]
            ]
            let merges = [
                              {s: {r: 0, c: 0}, e: {r: 0, c: 1}},
                              {s: {r: 0, c: 2}, e: {r: 0, c: 3}},
                              {s: {r: 0, c: 4}, e: {r: 0, c: 5}},
                              {s: {r: 0, c: 6}, e: {r: 0, c: 7}},
                      ]
            exportExcel(data, this.downFile.name, merges)
          }else {
            this.$message.warning("无图表数据！")
          }
        }
      },
      rollScrollShow(n,o){
        // this.loading = true
        if(n!=o){
          this.GetCompareRatio(); //同比
          this.GetCompareChain(); //环比
          this.GetProjectItemEnergy();
          this.GetPlan(); //计划
          this.GetProJectInfo();//项目信息
          this.GetproportionPrev(); //上月分类能耗
          // setTimeout(item=>{
          //   this.loading = false
          // },2000)
        }
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      for (let i = 1; i <= 31; i++) {
        this.xmonth.push(i + "日");
      }
      this.GetreeBuilding();
      this.canvasDataRult();
      this.Getproportion();
      if(this.rollScrollShow){
        this.GetCompareRatio(); //同比
        this.GetCompareChain(); //环比
        this.GetProjectItemEnergy();
        this.GetPlan(); //计划
        this.GetProJectInfo();//项目信息
        this.GetproportionPrev(); //上月分类能耗
      }
      
    },
    methods: {
      handleScroll(){
        this.rollScrollShow = true;
      },
      //楼栋
      GetreeBuilding(){
        treeBuilding().then((res) => {
          this.loops = res.data.data.tree;
          this.GetCompareGrade();
        });
      },
      //能效等级
      async GetCompareGrade(){
          let promises = [];
          let promises1 = [];
          let monthdata = [];
          this.loops.forEach(item=>{
            let obj ={
              buildingId:item.id,
              date:dateFormat("YY-mm-dd",this.date)+'T00:00:00Z',
              range:"MONTH",
              powerType:"",
            }
          promises.push(BuildingConsumption(obj));
          let obj1 ={
              buildingId:item.id,
              date:dateFormat("YY-mm-dd",perMonth(this.date))+'T00:00:00Z',
              range:"MONTH",
              powerType:"",
            }
          promises1.push(BuildingConsumption(obj1));
        })
          this.loops[0].children.forEach(item=>{
            let obj ={
              buildingId:item.id,
              date:dateFormat("YY-mm-dd",this.date)+'T00:00:00Z',
              range:"MONTH",
              powerType:"",
            }
          promises.push(BuildingConsumption(obj));
          let obj1 ={
              buildingId:item.id,
              date:dateFormat("YY-mm-dd",perMonth(this.date))+'T00:00:00Z',
              range:"MONTH",
              powerType:"",
            }
          promises1.push(BuildingConsumption(obj1));
        })
        Promise.all(promises).then((res) => {
          let pointsArray = res.map((r) =>
            r.data.data.result ? r.data.data.result : []
          );
          monthdata = pointsArray;
          //上月
          Promise.all(promises1).then((res) => {
            let pointsArray = res.map((r) =>
              r.data.data.result ? r.data.data.result : []
            );
            this.tableRank = []
            pointsArray.forEach((data,index)=>{
              let total = (
                data.powerSC +
                data.heatSC +
                data.waterSC +
                data.coolingSC
              ).toFixed(2);
              let total1 = (
                monthdata[index].powerSC +
                monthdata[index].heatSC +
                monthdata[index].waterSC +
                monthdata[index].coolingSC
              ).toFixed(2);
              if(index==0){
                this.tableRank.push({
                  name:this.loops[index].name,
                  total_grade:total1-total>0?'A':"B",
                  total_rank:"",
                  power_grade:monthdata[index].powerSC-data.powerSC>0?'A':"B",
                  power_rank:"",
                  water_grade:monthdata[index].waterSC-data.waterSC>0?'A':"B",
                  water_rank:"",
                  heat_grade:monthdata[index].heatSC-data.heatSC>0?'A':"B",
                  heat_rank:"",
                  cooling_grade:monthdata[index].coolingSC-data.coolingSC>0?'A':"B",
                  cooling_rank:""
                })  
              }else{
                this.tableRank.push({
                  name:this.loops[0].children[index-1].name,
                  total_grade:total1-total>0?'A':"B",
                  total_rank:"",
                  power_grade:monthdata[index].powerSC-data.powerSC>0?'A':"B",
                  power_rank:"",
                  water_grade:monthdata[index].waterSC-data.waterSC>0?'A':"B",
                  water_rank:"",
                  heat_grade:monthdata[index].heatSC-data.heatSC>0?'A':"B",
                  heat_rank:"",
                  cooling_grade:monthdata[index].coolingSC-data.coolingSC>0?'A':"B",
                  cooling_rank:""
                })
              }
              
            })


            if(this.$store.getters.projectId==18||this.$store.state.getters.projectId==4){
              this.tableRank[0].total_rank = "1"
              this.tableRank[0].power_rank = "1"
              this.tableRank[0].water_rank = "--"
              this.tableRank[0].water_grade = "--"
              return
            }

            if((this.tableRank[0].total_grade=='A'&&this.tableRank[1].total_grade=='A'&&this.tableRank[2].total_grade=='A')||(this.tableRank[0].total_grade=='B'&&this.tableRank[1].total_grade=='B'&&this.tableRank[2].total_grade=='B')){
              this.tableRank[0].total_rank = "1"
              this.tableRank[1].total_rank = "1"
              this.tableRank[2].total_rank = "1"
            }else if(this.tableRank[0].total_grade=='A'&&this.tableRank[1].total_grade=='A'&&this.tableRank[2].total_grade=='B'){
              this.tableRank[0].total_rank = "1"
              this.tableRank[1].total_rank = "1"
              this.tableRank[2].total_rank = "2"
            }else if(this.tableRank[0].total_grade=='B'&&this.tableRank[1].total_grade=='B'&&this.tableRank[2].total_grade=='A'){
              this.tableRank[0].total_rank = "2"
              this.tableRank[1].total_rank = "2"
              this.tableRank[2].total_rank = "1"
            }else if(this.tableRank[0].total_grade=='A'&&this.tableRank[1].total_grade=='B'&&this.tableRank[2].total_grade=='B'){
              this.tableRank[0].total_rank = "1"
              this.tableRank[1].total_rank = "2"
              this.tableRank[2].total_rank = "2"
            }
  
  
            
            if((this.tableRank[0].power_grade=='A'&&this.tableRank[1].power_grade=='A'&&this.tableRank[2].power_grade=='A')||(this.tableRank[0].power_grade=='B'&&this.tableRank[1].total_grade=='B'&&this.tableRank[2].power_grade=='B')){
              this.tableRank[0].power_rank = "1"
              this.tableRank[1].power_rank = "1"
              this.tableRank[2].power_rank = "1"
            }else if(this.tableRank[0].power_grade=='A'&&this.tableRank[1].power_grade=='A'&&this.tableRank[2].power_grade=='B'){
              this.tableRank[0].power_rank = "1"
              this.tableRank[1].power_rank = "1"
              this.tableRank[2].power_rank = "2"
            }else if(this.tableRank[0].power_grade=='B'&&this.tableRank[1].power_grade=='B'&&this.tableRank[2].power_grade=='A'){
              this.tableRank[0].power_rank = "2"
              this.tableRank[1].power_rank = "2"
              this.tableRank[2].power_rank = "1"
            }else if(this.tableRank[0].power_grade=='A'&&this.tableRank[1].power_grade=='B'&&this.tableRank[2].power_grade=='B'){
              this.tableRank[0].power_rank = "1"
              this.tableRank[1].power_rank = "2"
              this.tableRank[2].power_rank = "2"
            }

           
          })
        })
      },
      //项目信息
      async GetProJectInfo() {
        let response = await GetProJectInfo();
        this.getinfo = response.data.data.project;
      },
      //计划与实际
      async GetPlan() {
        let obj = {
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          projectId: this.$store.state.project.currentProject.projectId,
          buildingIds: "",
        };
        let response = await planAndReality(obj);
        let list = response.data.data.list[0];
          this.tableDataPlan = [
          {
            energy_plan: list.plan&&list.plan.electric ? list.plan.electric.toFixed(2) : "0",
            energy_reality: list.reality.power.toFixed(2),
            energy_diff:list.plan&&list.plan.electric?((list.reality.power-list.plan.electric)/list.plan.electric*100).toFixed(2):0,
            heat_plan: list.plan&&list.plan.heat ? list.plan.heat.toFixed(2) : "0",
            heat_reality: list.reality.heat.toFixed(2),
            heat_diff:list.plan&&list.plan.heat?((list.reality.heat-list.plan.heat)/list.plan.heat*100).toFixed(2):0,
            water_plan: list.plan&&list.plan.water ? list.plan.water.toFixed(2) : "0",
            water_reality: list.reality.water.toFixed(2),
            water_diff:list.plan&&list.plan.water?((list.reality.water-list.plan.water)/list.plan.water*100).toFixed(2):0,
            cooling_plan: list.plan&&list.plan.cooling ? list.plan.cooling.toFixed(2) : "0",
            cooling_reality: list.reality.cooling.toFixed(2),
            cooling_diff:list.plan&&list.plan.cooling?((list.reality.cooling-list.plan.cooling)/list.plan.cooling*100).toFixed(2):0,
          },
        ];
        
      },
      //分类能耗 
      async Getproportion() {
        let obj = {
          projectId: this.$store.state.project.currentProject.projectId,
          range: "MONTH",
          date:dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          powerType:"",
  
        };
        let response = await ProjectConsumption(obj);
        let data = response.data.data.result;
        this.loading = false
        data.energy = data.power
        data.energySC = data.powerSC
        this.tableData = [
          {
            total: (
              data.powerSC +
              data.heatSC +
              data.waterSC +
              data.coolingSC
            ).toFixed(2)+" tce",
            num: (
              data.powerSC +
              data.heatSC +
              data.waterSC +
              data.coolingSC
            ).toFixed(2),
            energy: data.power.toFixed(2)+" kWh",
            heat: data.heat.toFixed(2)+" GJ",
            water: data.water.toFixed(2)+" m³",
            cooling: data.cooling.toFixed(2)+" GJ",
          },
        ];
        let total = (
          data.power +
          data.heat +
          data.water +
          data.cooling
        ).toFixed(2);
        this.tableSort = [
          {
            energy: data.power.toFixed(2),
            energylv:(data.power / total).toFixed(2) * 100,
            heat: data.heat.toFixed(2),
            heatlv: (data.heat / total).toFixed(2) * 100,
            water: data.water.toFixed(2),
            waterlv: (data.water / total).toFixed(2) * 100,
            cooling: data.cooling.toFixed(2),
            coolinglv: (data.cooling / total).toFixed(2) * 100,
          },
        ];
        this.ClassifiedData = [
          { value: data.powerSC.toFixed(2), name: "电" },
          // { value: data.heatSC.toFixed(2), name: "热" },
          { value: data.waterSC.toFixed(2), name: "水" },
          // { value: data.coolingSC.toFixed(2), name: "冷" },
        ];
        this.loading = false
      },
      //上个月总体情况查询
      async GetproportionPrev() {
        let obj = {
          projectId: this.$store.state.project.currentProject.projectId,
          range: "MONTH",
          date:dateFormat("YY-mm-dd", perMonth(this.date)) + "T00:00:00Z",
          powerType:"",
  
        };
        let response = await ProjectConsumption(obj);
        let data = response.data.data.result;
        let total = (
              data.powerSC +
              data.heatSC +
              data.waterSC +
              data.coolingSC
            ).toFixed(2)
          this.PrevTotal = total
      },
      //分项能耗
      async GetProjectItemEnergy() {
        let obj = {
          projectId: this.$store.state.project.currentProject.projectId,
          itemType: "",
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          range: "MONTH",
        };
        let response = await ProjectItemEnergy(obj);
        let data = response.data.data.result;
        this.tableItem = [];
        let list = [];
        this.ItemizedChart = [];
        for (let item in data) {
          list.push(data[item].toFixed(2));
          this.ItemizedChart.push({ value: data[item].toFixed(2), name: item });
        }
        this.ItemizedChart.push();
        console.log(this.ItemizedChart,"this.ItemizedChart")
        let total = 0;
        list.forEach((ele) => {
          total += Number(ele);
        });
        this.tableItem = [
          {
            air: Number(list[0]).toFixed(2),
            airlv: list[0]!=0?((list[0] / total) * 100).toFixed(2):'0',
            illumine: Number(list[1]).toFixed(2),
            illuminelv: list[1]!=0?((list[1] / total) * 100).toFixed(2):"0",
            power: Number(list[2]).toFixed(2),
            powerlv: list[2]!=0?((list[2] / total) * 100).toFixed(2):"0",
            other: 0.0,
            other: 0.0,
          },
        ];
        let datalist = [
          {name:"空调",val:this.tableItem[0].airlv},
          {name:"照明",val:this.tableItem[0].illuminelv},
          {name:"动力",val:this.tableItem[0].powerlv},
        ]
        this.maxsuboption = datalist.sort((a, b) => { return b.val-a.val })[0]
      },
      //曲线
      async canvasDataRult() {
        let obj = {
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          powerType: "",
          projectId: this.$store.state.project.currentProject.projectId,
          range: "MONTH",
        };
        let response = await convertedStandardCoal(obj);
        this.ClassData = response.data.data.result;
        this.EnergyReportData1 = [
          {
            name: "电",
            type: "bar",
            stack: 'Ad',
            barWidth: 15,
            emphasis: {
              focus: 'series'
            },
            data: this.ClassData.electricity.map((e) =>
              e == null ? "0" : e.toFixed(2)
            ),
          },
          {
            name: "水",
            type: "bar",
            stack: 'Ad',
            barWidth: 15,
            emphasis: {
              focus: 'series'
            },
            data: this.ClassData.water.map((e) =>
              e == null ? "0" : e.toFixed(2)
            ),
          },
          {
            name: "热",
            type: "bar",
            stack: 'Ad',
            barWidth: 15,
            emphasis: {
              focus: 'series'
            },
            data: this.ClassData.heat.map((e) => (e == null ? "0" : e.toFixed(2))),
          },
          {
            name: "冷",
            type: "bar",
            stack: 'Ad',
            barWidth: 15,
            emphasis: {
              focus: 'series'
            },
            data: this.ClassData.cooling.map((e) =>
              e == null ? "0" : e.toFixed(2)
            ),
          },
        ];
      },
      //能耗同比
      async GetCompareRatio() {
        let promises = [];
        this.tableDataRatio = [];
        let currList = ["ELECTRICITY", "WATER", "HEAT", "COOLING"];
        currList.forEach((element) => {
          let obj = {
            projectId: this.$store.state.project.currentProject.projectId,
            compareType: "SEPARATED",
            date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
            dateRange: "MONTH",
            powerType: element,
          };
          promises.push(ProjectCompareClassifiedPower(obj));
        });
        Promise.all(promises).then((res) => {
          let pointsArray = res.map((r) => r.data.data.data[0]);
          this.EnergyReportRatioData = pointsArray;
          let list = this.typelist
          this.EnergyReportRatioData.forEach((item,index)=>{
            if(index==0||index==1){
              this.tableDataRatio.push({
                name: list[index].name,
                unit:list[index].unit,
                period: item[1].toFixed(2),
                same: item[0].toFixed(2),
                lv:Number(item[1] - item[0])==0?0:item[0] == 0
                    ? 100
                    : Number(((item[1] - item[0]) /
                        item[0]) *
                      100).toFixed(2),
                growth: Number(item[1] - item[0]).toFixed(2)
              })
            }else{
              this.tableDataRatio.push({
                name: list[index].name,
                unit:list[index].unit,
                period: "--",
                same: "--",
                lv:"--",
                growth: "--"
              })
            }
            
          })
        });
      },
      //能耗环比
      async GetCompareChain() {
        let promises = [];
        this.tableDataChain = []
        let currList = ["ELECTRICITY", "WATER", "HEAT", "COOLING"];
        currList.forEach((element) => {
          let obj = {
            projectId: this.$store.state.project.currentProject.projectId,
            compareType: "ALTERNATE",
            date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
            dateRange: "MONTH",
            powerType: element,
          };
          promises.push(ProjectCompareClassifiedPower(obj));
        });
        Promise.all(promises).then((res) => {
          let pointsArray = res.map((r) => r.data.data.data[0]);
          this.EnergyReportChinData = pointsArray;
          let list = this.typelist
          pointsArray.forEach((item,index)=>{
            if(index==0||index==1){
              this.tableDataChain.push({
              name: list[index].name,
              unit:list[index].unit,
              period: item[1].toFixed(2),
              same: item[0].toFixed(2),
              lv:Number(item[1] - item[0])==0?0:item[0] == 0
                  ? 100
                  : Number(((item[1] - item[0]) /
                      item[0]).toFixed(2) *
                    100).toFixed(2),
              growth: Number(item[1] - item[0]).toFixed(2)
            })
            }else{
              this.tableDataChain.push({
              name: list[index].name,
              unit:list[index].unit,
              period:"--",
              same: "--",
              lv:"--",
              growth:"--",
            })
            }
          })
        });
      },
      perW() {
        let week = getAppointedDate(this.date, 1, 1);
        this.date = new Date(week.startDate);
      },
      nextW() {
        let week = getAppointedDate(this.date, 1, -1);
        this.date = new Date(week.startDate);
      },
      perD() {
        this.date = perDay(this.date);
      },
      nextD() {
        this.date = nextDay(this.date);
      },
      perM() {
        this.date = perMonth(this.date);
      },
      nextM() {
        this.date = nextMonth(this.date);
      },
      perY() {
        this.date = perYear(this.date);
      },
      nextY() {
        this.date = nextYear(this.date);
      },
    },
  };
  </script>
  
  <style scoped lang="less">
  .tip{
    padding:30px 0;
  }
  .loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}
  @keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
  /deep/.el-table{
    border: 1px solid #cccccc;
    border-bottom: none;
  }
  /deep/.el-table td,
  /deep/.el-table th.is-leaf,
  .el-table--border th,
  /deep/.el-table__fixed-right-patch {
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
  }
  /deep/.el-table--border,
  /deep/.el-table--group {
    border: 1px solid #cccccc;
    border-bottom: none;
  }
  /deep/.el-table--border th {
    border-right: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
  }
  .el-table::before {
    background-color: #cccccc;
  }
  .tabs-container {
    display: flex;
    flex-direction: row;
    justify-content: space-left;
    height: 4.5vh;
    span {
      line-height: 60rem;
      border-top: 2px solid #fff;
      font-size: 18rem;
      font-weight: 400;
      margin: 0 10rem;
      cursor: pointer;
      font-weight: bold;
    }
    .active {
      color: #0d94ff;
      border-top: 2px solid #0d94ff;
    }
  }
  .EnergyReport {
    overflow: auto;
    height: 100%;
    font-size: 18rem;
    background-color: #F5F7F9;
  }
  .title {
    background: #ffffff;
    height: 8vh;
    padding: 0 30rem;
    width: 100%;
    margin-bottom: 10rem;
    .demonstration {
      margin-right: 10rem;
    }
    .block {
      margin-right: 80rem;
    }
    .dateSelect {
      margin-right: 10rem;
    }
    .per {
      margin-left: 10rem;
    }
    .el-radio {
      margin-right: 20rem;
    }
    .area {
      cursor: pointer;
    }
  }
  .cont {
    width: 100%;
    background: #fff;
    margin-bottom: 10rem;
    font-size: 18rem;
    .line {
      font-size: 18rem;
      font-weight: bold;
      color: #ffffff;
      line-height: 4vh;
      padding-left: 20rem;
      background: linear-gradient(
        90deg,
        #002b66 0%,
        #81add7 50%,
        rgba(13, 148, 255, 0) 100%
      );
    }
    .text {
      span {
        color: #0d94ff;
      }
      .red{
        color: #FD4238 !important;
      }
      .no{
        color: #000 !important;
      }
    }
    .panel {
      padding: 20rem 40rem;
      .text {
        margin-bottom: 30px;
      }
    }
    .Notes {
      text-align: center;
      color: #999999;
      font-size: 14rem;
      padding: 20rem;
      margin-bottom: 30px;
    }
  }
  /deep/.el-table th {
    background: #ffffff !important;
    text-align: center;
    font-weight: 500;
    color: #333333;
    font-size: 18rem;
  }
  /deep/.el-table td {
    background: #ffffff !important;
    text-align: center;
    font-weight: 500;
    color: #333333;
    font-size: 18rem;
  }
  .chin {
    overflow: hidden;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 20rem;
    .land {
      width: 25%;
      .item {
        height: 35vh;
      }
    }
  }
  .Schedule {
    p {
      font-size: 18rem;
      line-height: 40rem;
      span {
        color: #0d94ff;
        cursor: pointer;
      }
    }
  }
  </style>
  